import $ from "jquery";
import React from "react";
import { UIButtonProps } from "./UIButton";
import message from "common/message/source/MessageSource";

export interface UIButtonCloseProps extends UIButtonProps {}

export default UIButtonClose;

function UIButtonClose(props: UIButtonCloseProps) {
  let $button;

  const classNames: string[] = ["button", props.kind || "page"];

  if (props.className) {
    classNames.push(props.className);
  }

  return (
    <button
      ref={(element) => ($button = $(element!))}
      type="button"
      className={classNames.join(" ")}
      onClick={() => {
        $button.closest("div.popup-content").children("div.popup-header").children("button.btn.bg-transparent.btn-close").click();
      }}
    >
      {message.get("common.label.close", "닫기")}
    </button>
  );
}
